import { CustomerT } from "../../../types";
import { CustomerContactInfo } from "./CustomerContactInfo";
import React from "react";

interface CustomerContactProps {
  customer: CustomerT;
}

export const CustomerContact: React.FC<CustomerContactProps> = ({ customer }) => (
  <div>
    <div className="md:ml-[1.3em] biglg:ml-[1em] ml-[-1em] gap-[7px] 540:ml-[5em] 360:ml-[-0.5em]" style={{ display: "flex", }}>
      <div className="xl:ml-[25px]">
        <CustomerContactInfo title="Email Address" value={customer?.email || 'N/A'} />
        <CustomerContactInfo title="Phone Number" value={customer?.phone || 'N/A'} />
      </div>
      <div className="">
        <CustomerContactInfo title="Address" value={customer.address || 'N/A'} />
        {/* <CustomerContactInfo title="Last Active" value={customer?.createdAt} /> */}
      </div>
    </div>
  </div>
);
